function ProofOfPlayCtrl(ProofPlayService, $stateParams, $state, ToastsService, $scope) {
  "ngInject";

  let vm = this;

  $scope.tabIndex = 6;

  $scope.$watch('tabIndex', function (toTab, fromTab) {
    if (toTab !== undefined) {
      switch (toTab) {
        case 0:
          return $state.go('main.tenantDetails', {tenantId: $stateParams.tenantId});
        case 1:
          return $state.go('main.tenantManagedDevices', {tenantId: $stateParams.tenantId});
        case 2:
          return $state.go('main.tenantUnmanagedDevices', {tenantId: $stateParams.tenantId});
        case 3:
          return $state.go('main.tenantLocations', {tenantId: $stateParams.tenantId});
        case 4:
          return $state.go('main.tenantOverlays', {tenantId: $stateParams.tenantId});
        case 5:
          return $state.go('main.tenantLogs', {tenantId: $stateParams.tenantId});
        case 6:
          return $state.go('main.tenantProofPlay', {tenantId: $stateParams.tenantId});
      }
    }
  });

  // gross hack to be able to switch back to list
  // (this should all be handled by ui-router!!!)
  $scope.popTabIndex = 0;
  $scope.changeToReportList = () => {
    $scope.popTabIndex = 0;
  };

  return vm;
};


export {ProofOfPlayCtrl}
